import React from "react";

export default function ApprovalCode() {
  return (
    <div className="apploval-code">
      <span>SA-AGNA-230042</span>
    </div>
  );
}
